require("./exantCostWarrant.scss");

// @ vendor
const React = require("react");
const { withRouter } = require("react-router-dom");
const PropTypes = require("prop-types");
const { FormattedText, formatText } = require('core/i18n').i18n;

// @components
const BlockInfo = require("components/contactCenter/blockInfo/blockInfo");
const BrokerExAntSection = require("components/commons/brokerExAntSection/brokerExAntSection");
const { LoadingSection } = require('commonsComponents/loadingSection');
const BrokerDataItem = require("components/commons/brokerDataItem/brokerDataItem");

// @helpers
const {
    formatAmount,
    formatCurrency,
    formatWithoutRound,
    formatPercentage
} = require('utilities/currencyHelper');
// @ constants
const {
    CHARGE_ACCOUNT_PREFIX,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    BROKER_ORDER_TYPE_TO_MARKET,
    POTENTIAL_SELL_WARRANT_COSTS,
    POTENTIAL_COST,
    POTENTIAL_COST_TYPE
} = require('constants/index');
const { DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

class ExantCostBuyWarrants extends React.Component {
    constructor(props) {
        super(props);

        this.buildDetails = this.buildDetails.bind(this);
        this.buildLeftColumn = this.buildLeftColumn.bind(this);
        this.buildRightColumn = this.buildRightColumn.bind(this);
    }

    componentDidMount() {
        const { fetchExtantCostWarrantsBuy, history } = this.props
        fetchExtantCostWarrantsBuy(history);
    }

    getOrderType(orderType) {
        if (orderType === BROKER_ORDER_TYPE_TO_MARKET) {
            return formatText('brokerWarrantBuy-warrantBuyStep1ToMarketLabel');
        } else if (orderType === BROKER_ORDER_TYPE_FOR_THE_BEST) {
            return formatText('brokerWarrantBuy-warrantBuyStep1ForTheBestLabel');
        } else {
            return formatText('brokerWarrantBuy-warrantBuyStep1LimitedLabel');
        }
    }

    buildLeftColumn() {
        //orderTypeValue
        const { stockDescription, step1, stockContract, immWarrantBuy } = this.props;
        const titleQuantity = step1.get('orderTypeOption') === 'titles' ? step1.get('buyForValue') : step1.get('titleQuantity')
        const orderType = step1.get('orderTypeOption');
        const orderTypeText = this.getOrderType(orderType);
        const validityDate = step1.get('validityDate');
        const formattedValidityDate = validityDate
            ? validityDate.format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT))
            : '-';
        const controlDigit = stockContract.get('controlDigit');
        const productNumber = stockContract.get('productNumber');
        const walletNumber = stockContract.get('walletNumber');
        const contractValues = `${CHARGE_ACCOUNT_PREFIX}${controlDigit}${productNumber}${walletNumber}`;
        const associatedAccountAlias = stockContract.get('associatedAccountAlias');
        const associatedAccount = stockContract.get('associatedAccount')
        const balanceLabel = formatText('brokerWarrantBuy-summaryBalanceTitle');
        const walletBalance = stockContract.getIn(['associatedAccountBalance', 'amount']);
        const walletCurrency = stockContract.getIn(['associatedAccountBalance', 'currency']);

        const descriptionAccount = `${associatedAccountAlias} ${associatedAccount} (${balanceLabel}: ${formatAmount(walletBalance)} ${formatCurrency(walletCurrency)})`
        let estimatedAmount = `${formatWithoutRound(walletBalance)} ${formatCurrency(walletCurrency)}`;
        const dataExtant = immWarrantBuy.getIn(['exAnteCostsList']);
        const estimatedBaseAmount = dataExtant.get('estimatedBaseAmount');
        const estimatedBaseAmountExchanged = dataExtant.get('estimatedBaseAmountExchanged');
        if(!!estimatedBaseAmount){
            const estimatedBaseAmountValue = estimatedBaseAmount.get('amount');
            const estimatedBaseAmountCurrency = estimatedBaseAmount.get('currency');
            if (!!estimatedBaseAmountExchanged) {
                const estimatedBaseAmountExchangedValue=estimatedBaseAmountExchanged.get('amount');
                const estimatedBaseAmountExchangedCurrency=estimatedBaseAmountExchanged.get('currency')
                estimatedAmount = `${formatWithoutRound(
                    estimatedBaseAmountValue,
                    2
                )} ${formatCurrency(
                    estimatedBaseAmountCurrency
                )} | ${formatWithoutRound(
                    estimatedBaseAmountExchangedValue,
                    2
                )} ${formatCurrency(estimatedBaseAmountExchangedCurrency)}`;
            } else {
                estimatedAmount = `${formatWithoutRound(
                    estimatedBaseAmountValue,
                    2
                )} ${formatCurrency(estimatedBaseAmountCurrency)}`;
            }
        }
        return (
            <div className="broker-buy-warrant-description__left-column-container">
                <div className="broker-buy-warrant-description__column-title">
                    <FormattedText value="brokerWarrantBuy-orderDataTitle" />
                </div>
                <BrokerDataItem
                    label={"brokerWarrantBuy-warrantToBuy"}
                    data={stockDescription}
                />
                <BrokerDataItem
                    label={"brokerWarrantBuy-estimatedAmount"}
                    data={estimatedAmount}
                    tooltipTitleKey={`brokerWarrantBuy-estimatedAmountTooltipTitle`}
                    tooltipContentKey={`brokerWarrantBuy-estimatedAmountComplexTooltip`}
                    eventCategory="orden compra acciones/paso 2"
                    eventTag={"orden de compra/importe base estimado"}
                    complexTooltip
                />
                <BrokerDataItem
                    label={"brokerWarrantBuy-titles"}
                    data={`${titleQuantity}`}
                />
                <BrokerDataItem
                    label={"brokerWarrantBuy-orderType"}
                    data={`${orderTypeText}`}
                />
                <BrokerDataItem
                    label={"brokerWarrantBuy-validityPeriod"}
                    data={formattedValidityDate}
                />
                <BrokerDataItem
                    label={"brokerWarrantBuy-valueContact"}
                    data={contractValues}
                />
                <BrokerDataItem
                    label={"brokerWarrantBuy-firstHolder"}
                    data={stockContract.get('firstTitular')}
                />
                <BrokerDataItem
                    label={"brokerWarrantBuy-associatedAccount"}
                    data={descriptionAccount}
                />
            </div>
        );
    }

    buildRightColumn() {
        const { immWarrantBuy } = this.props;
        const dataExtant = immWarrantBuy.getIn(['exAnteCostsList']);
        const exAnteCostList = dataExtant.getIn(['exAnteCostList']);
        let data, potentialSellWarrantCostsText;
        if (immWarrantBuy.getIn(['exAnteDataFetching'])) {
            data = <LoadingSection />;
        } else if (exAnteCostList) {
            data = exAnteCostList.map((item, index) => (
                item.get("type") !== POTENTIAL_COST &&
                    (
                        <BrokerExAntSection
                            context="brokerWarrantBuy"
                            eventCategory="orden compra fondos/paso 2"
                            section={item}
                            key={index}
                            complexTooltip={true}
                        />
                    )
            ));

            const potentialSellWarrantCosts  = exAnteCostList.find(
                (item) => item.get("descriptionKey") === POTENTIAL_SELL_WARRANT_COSTS
            );

            if (potentialSellWarrantCosts && potentialSellWarrantCosts.get('type') === POTENTIAL_COST) {
                const dataPotentialCosts = potentialSellWarrantCosts.get('details').toJS()[0];
                const currency = formatCurrency(dataPotentialCosts.currency ? dataPotentialCosts.currency : 'EUR');
                const amount = formatWithoutRound(dataPotentialCosts.amount, 2);
                const immPercentage = formatPercentage(dataPotentialCosts.percentage, 2);
                const formatAmount = `${amount} ${currency}`;

                potentialSellWarrantCostsText = formatText('brokerWarrantBuy-exantCost_potentialCost_footer', [formatAmount, immPercentage]);
            }
        }
        return (
            <div className="broker-buy-warrant-description__right-column-container">
                {data}

                <div className="broker-buy-warrant-description__right-column-potential-sell-warrants-container">
                    {potentialSellWarrantCostsText}
                </div>
            </div>
        );
    }

    buildDetails(title, footer = null) {
        return (
            <React.Fragment>
                <div className="broker-buy-warrant-description__title-description">
                    {title}
                </div>
                <div className="broker-buy-warrant-description__web-wrapper__container">
                    {this.buildLeftColumn()}
                    {this.buildRightColumn()}
                </div>
                <span className="broker-buy-warrant-description__footer">
                    {footer}
                </span>
            </React.Fragment>
        );
    }

    renderExtantDataWeb() {
        const { immWarrantBuy } = this.props;
        const dataExtant = immWarrantBuy.getIn(['exAnteCostsList']);
        const exAnteCostList = dataExtant.getIn(['exAnteCostList']);
        const potentialSellWarrantCosts  = exAnteCostList && exAnteCostList.find(
            (item) => item.get("descriptionKey") === POTENTIAL_SELL_WARRANT_COSTS
        );
        return (
            <div className="broker-buy-warrant-description__web-wrapper">
                <div className="broker-buy-warrant-description__web-wrapper__container">
                    {this.buildLeftColumn()}
                    {this.buildRightColumn()}
                </div>
                {potentialSellWarrantCosts && potentialSellWarrantCosts.get('type') === POTENTIAL_COST_TYPE &&
                    <div className="broker-buy-warrant-description__footer">
                        <FormattedText
                            value="brokerWarrantBuy-extantCost_footer_description"
                        />
                    </div>
                }
            </div>
        );
    }

    render() {
        return __CONTACT_CENTER__ ? (
            <BlockInfo extraClass="broker-buy-warrant-description__block-info">
                {this.buildDetails(
                    formatText('brokerWarrantBuy-extantCost_description_cc'),
                    formatText('brokerWarrantBuy-extantCost_footer_description_cc')
                )}
            </BlockInfo>
        ) : (
            <div>
                {this.renderExtantDataWeb()}
            </div>
        );
    }
}

ExantCostBuyWarrants.propTypes = {
    productCurrency: PropTypes.object.isRequired,
    productIso: PropTypes.object.isRequired,
    productType: PropTypes.object.isRequired,
    stockContract: PropTypes.object.isRequired,
    stockDescription: PropTypes.object.isRequired,
    step1: PropTypes.object.isRequired,
    fetchExtantCostWarrantsBuy: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immWarrantBuy: PropTypes.object.isRequired,
};

module.exports.constructor = ExantCostBuyWarrants;

export default withRouter(ExantCostBuyWarrants);
